import axios from './axiosInstance';

export const login = async ({
  email,
  password
}) => {
  try{
    const response = await axios({
      url : '/login',
      method : 'POST',
      data : {
        email : email,
        password : password,
        role : 'super_admin'
      }
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}

export const updatePassword = async ({
  data
}) => {
  try{
    const response = await axios({
      url : '/update-password',
      method : 'POST',
      data : data
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}

export const updateAdminPassword = async ({
  data
}) => {
  try{
    const response = await axios({
      url : '/update-admin-password',
      method : 'POST',
      data : data
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}